import React, { Fragment } from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import Cards from "./cards/cards";
import Spinner from "../common/spinner";
import "./cards/cards.css";

const PortfoliosCards = ({
  data,
  displayNoProf,
  dataFetching,
  sortingDataError,
  compare,
  setMyPortfolios,
  noSearchResult,
  failedToLoadData,
  no_live_or_backtest_data,
  simulations,
  create_button
}) => {
  // setting my_portfolios
  if (data.length > 0) {
    setTimeout(() => setMyPortfolios(data), 0);
  }
  return (
    <div className="myPortfolio_cardHolder_grid transition-2s">
      {create_button &&
          <div className="firstCard_m">
            <div className="card">
              <Link className="LinkStyle" to="/create">
                <div className="cardMainBody textCenter firstCard">
                  <div></div>
                  <i className="fa fa-plus fa-3x" aria-hidden="true" />
                  <div className="cardTitle">Create New</div>
                </div>
              </Link>
            </div>
            </div>
      }
      {/* diplaying portfolios without client portfolio id */}
      {data && data.length ? (
        <Fragment>
          {data.map((portfolio, i) => {
            return (
              <Cards
                key={i}
                keyData={i}
                data={portfolio}
                sortedData={data}
                compare={compare}
              />
            );
          })}
        </Fragment>
      ) : null}
      {(data.length === 0 &&
        displayNoProf === false &&
        sortingDataError === false &&
        noSearchResult === false &&
        no_live_or_backtest_data === false) ||
      dataFetching ||
      (dataFetching === false &&
        sortingDataError &&
        failedToLoadData === false &&
        no_live_or_backtest_data === false) ? (
        <div className="PaddingSpinner">
          <Spinner />
        </div>
      ) : null}
      {dataFetching === false && noSearchResult === true ? (
        <div className="search_message">No search results found</div>
      ) : null}
      {failedToLoadData ||
      (no_live_or_backtest_data && noSearchResult === false) ? (
        <div className="search_message">
          Failed to load / No data to display
        </div>
      ) : null}
    </div>
  );
};


export default connect(null, (dispatch) => ({
  setMyPortfolios: (payload) =>
    dispatch({
      type: "SET_LIST_OF_MYPORTFOLIOS",
      payload,
    }),
}))(PortfoliosCards);




// WEBPACK FOOTER //
// ./src/components/myPortfolios/PortfolioCards.jsx